import axios from "axios";
import { API_BASE_URL } from "../constants/api";
import { ACCESS_TOKEN } from "../constants/auth";

const ApplicationService = {};
ApplicationService.getApplications = async (page, limit) => {
  return axios({
    method: "get",
    url: API_BASE_URL + "/api/application/get/my",
    params: {
      page,
      limit,
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  });
};

ApplicationService.createApplication = async (
  professionPriorityAId,
  professionPriorityBId,
  professionPriorityCId
) => {
  let data = new FormData();
  data.append("professionPriorityAId", professionPriorityAId);
  data.append("professionPriorityBId", professionPriorityBId);
  data.append("professionPriorityCId", professionPriorityCId);
  return axios({
    method: "post",
    url: API_BASE_URL + "/api/application/create",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  });
};
export default ApplicationService;
